/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	if(jQuery('body').hasClass('page') || jQuery('body').hasClass('single-report') || jQuery('body').hasClass('single-hellhole')){
		console.log(jQuery('.inner-content').find("p:first").text());
		var firstP = jQuery('.inner-content').find("p:first");
		console.log(firstP.hasClass('byline'));
		firstP.addClass('subheader');
		/*
		if( firstP.hasClass('byline') ){
			 console.log('byline')
			 console.log(jQuery('.inner-content').find("p:nth-child(2)").text());
			var secondP = jQuery('.inner-content').find("p:nth-child(2)");
			secondP.addClass('subheader');

		}else{
			firstP.addClass('subheader');
		}
		*/
		
		
	}
	if(jQuery('body').hasClass('post-type-archive-report')){

	jQuery( "#current-reports li a" ).click(function() {
		if(jQuery(this).hasClass('close')){
			jQuery('#more-info').css('display', 'none');
		}else{
			var htitle = jQuery(this).find( ".r_title" ).text();
			var hinfo = jQuery(this).find( ".r_info" ).text();
			console.log(htitle);
			console.log(hinfo );

			jQuery('#more-info').css('display', 'block');
			jQuery('#more-info-title').text(htitle);
			jQuery('#more-info-description').text(hinfo);
		}
		
	  });
	}



	
	  jQuery('a[href^="http://"], a[href^="https://"]').each(function(){ 


			var Url = jQuery(this).attr("href"); // Get current url
			
			


			if(Url.includes('portfolioofmh.com/jh')){
				var newURL  = Url.replace("http://portfolioofmh.com/jh", "http://www.judicialhellholes.org/");
				jQuery(this).attr('href', newURL);
			}

			if(Url.includes('www.portfolioofmh.com/jh')){
				var newURL  = Url.replace("http://www.portfolioofmh.com/jh", "http://www.judicialhellholes.org");
				jQuery(this).attr('href', newURL);
			}
           
			

		});

		jQuery('a[href^="http://"], a[href^="https://"]').each(function(){ 


			var Url = jQuery(this).attr("href"); // Get current url
			
			
			if( !Url.includes('https://www.judicialhellholes.org') && !Url.includes('http://www.judicialhellholes.org') ) {
				//console.log(Url);
				jQuery(this).attr('target','_blank');
			}

		
           
			

		});

		/*
		jQuery( ".menu .search" ).click(function() {
			console.log('search');
			//jQuery("#header-search-form").toggle();
			jQuery("header.header").addClass('header showSearch');
		  });
		 */ 	

		
		jQuery(document).click(function() {

			//if(jQuery("header.header").hasClass('header showSearch')){
				var container = jQuery("#searchText");
				var searchBtn = jQuery('.menu .search');

				console.log(event.target.id );
				var clicked = String( event.target.id );
				console.log(clicked );

				

				if( clicked=== 'searchBtn' ){
					jQuery("header.header").addClass('header showSearch');
					console.log('search');
					
				}
				else if (!container.is(event.target) && !container.has(event.target).length  ) {
					//container.hide();
					console.log('hide');
					jQuery("header.header").removeClass('showSearch');
					}
					else{

					}
				/*

				else{
					console.log('hide');
					jQuery("header.header").removeClass('showSearch');
				}
				*/

				
				
				
			//}
			


		  });



	
}); 
